<template>
  <div class="cadre-annonce w-100" :class="jel_getClassObject(content)">
    <div class="annonce bg-annonce">
      <div class="casino">
        <b-img-lazy
          :src="jel_getFichierSrc(content.image)"
          :alt="content.altImage"
          class="pr-1 logo-progressif"
        />
      </div>
      <div v-if="isProgressifActif && mntProgressif" cols="9" class="amount">
        <div
          class="overflow-hidden graphik_semibold d-flex align-items-start justify-content-center montant w-100"
          :class="`montant-${$i18n.locale}`"
        >
          <div v-if="$i18n.locale == 'en'" class="dollarsign">$</div>
          <div
            v-for="(chiffre, index) in arrMntProgressif"
            :key="index"
            class="align-items-center"
            :class="
              chiffre == ' ' || isNaN(chiffre)
                ? 'lot-valeur-num-espace'
                : 'container-chiffre lot-valeur-num'
            "
          >
            <span
              :class="[
                chiffre == ' ' || isNaN(chiffre)
                  ? 'separateur'
                  : 'case-chiffre chiffre d-flex align-items-center justify-content-center',
              ]"
            >
              {{ chiffre.replace(' ', '&nbsp;') }}
            </span>
          </div>
          <span v-if="$i18n.locale == 'fr'" class="dollarsign">$</span>
          <span class="approx" :class="$i18n.locale == 'en' ? 'en' : ''">{{
            $i18n.tc('messageComponent.approx')
          }}</span>
        </div>
      </div>
      <div v-else cols="9">
        <div class="error">{{ $i18n.tc('messageComponent.error') }}</div>
      </div>
      <div class="boutons w-100">
        <b-link v-bind="jel_getLienBinding(content.lien)" class="jouer"
          >{{ $i18n.tc('messageComponent.jouer') }}
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// Helpers
import { inEditor } from '@/helpers/AppHelpers';
import { formatMontant } from '@/helpers/StringHelpers';

export default {
  name: 'CarteCasinoGrosLot',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      casinoProgressif: null, // Objet contenant les progressifs retournés par le service
      test: null,
    };
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          jouer: 'Jouer',
          approx: 'Approx.',
          error: 'Le montant du prochain gros lot est à venir.',
        },
      },
      en: {
        messageComponent: {
          jouer: 'Play',
          approx: 'Approx.',
          error: 'The amount of the next jackpot is coming.',
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      getProgressifCasino: 'progressif/getProgressifCasino',
      getProgressifCasinoMontant: 'progressif/getProgressifCasinoMontant',
    }),
    arrMntProgressif() {
      return [...Array.from(formatMontant(this.mntProgressif).replace('$', ''))];
    },
    mntProgressif() {
      return this.getMontant(this.casinoProgressif.jackpot);
    },
    isProgressifActif() {
      if (inEditor) {
        return false;
      }
      return (
        typeof this.casinoProgressif != 'undefined' &&
        this.casinoProgressif != null &&
        this.casinoProgressif.actif === 'true'
      );
    },
  },
  mounted() {
    document.addEventListener('ejEventProgressifs', this.getCasinoProgressif);
  },
  beforeDestroy() {
    document.removeEventListener('ejEventProgressifs', this.getCasinoProgressif);
  },
  methods: {
    getMontant(montant) {
      return Math.trunc(montant);
    },
    getCasinoProgressif() {
      this.casinoProgressif = this.getProgressifCasino(this.content.idLot);
      return this.casinoProgressif;
    },
  },
};
</script>

<style lang="scss" scoped>
.cadre-annonce {
  display: flex;
  background-color: $couleur-blanc;
  text-align: center;
  width: 100%;
  position: relative;
  padding-top: 43vw;

  @include media-breakpoint-up(md) {
    height: 15.4vw;
    max-height: 169.5px;
    padding-top: unset;
  }
}
.annonce {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.bg-annonce {
  background-image: url('/dam/jel/casino/progressif/bg_lot-prog-casino.jpg');
}
.montant-fr.montant {
  color: $couleur-blanc;
}

.amount {
  font-size: 3vw;
  font-family: $font-graphik-medium;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: 100%;

  @include media-breakpoint-up(md) {
    top: 40%;
  }
  @include media-breakpoint-up(lg) {
    top: 45%;
  }
}

.error {
  color: $couleur-noir;
  font-size: 4vw;
  font-family: $font-graphik-semibold;
  line-height: 4vw;
  padding: 0 16px;
  position: absolute;
  left: 50%;
  top: 40%;
  width: 95%;
  transform: translate(-50%, 0%);

  @include media-breakpoint-up(md) {
    font-size: 1rem;
    line-height: 1rem;
    top: 40%;
    left: 0;
    transform: translate(0, 0);
  }
  @include media-breakpoint-up(lg) {
    font-size: 20px;
    line-height: 20px;
    top: 45%;
  }
}

span.case-chiffre {
  padding-top: 2px;
}

span.chiffre {
  background: $couleur-noir;
  border: 1px solid $couleur-blanc;
  border-radius: 4px;
  color: $couleur-blanc;
  font-family: $font-graphik-medium;
  font-size: 3.25vw;
  margin: 0;
  padding: 0;
  height: 5.5vw;
  width: 3.6725vw;
  zoom: 1;
  @include media-breakpoint-up(md) {
    border: 2px solid $couleur-blanc;
    border-radius: 4px;
    font-size: 21px;
    height: 33px;
    width: 26px;
  }
  @include media-breakpoint-up(lg) {
    font-size: 22px;
    height: 43px;
    width: 27px;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 30px;
    width: 35px;
  }
}

span.separateur {
  width: 1.5rem;
  @include media-breakpoint-up(md) {
    width: 2rem;
  }
  @include media-breakpoint-up(lg) {
    width: 3.5rem;
  }
}
.lot-valeur-num-espace {
  color: $couleur-blanc;
  font-size: 3.5vw;
  line-height: 5.5vw;
  @include media-breakpoint-up(md) {
    font-size: 2.5vw;
    line-height: 3.8vw;
  }
  @include media-breakpoint-up(lg) {
    font-size: 22px;
    line-height: 3.5vw;
  }
  @include media-breakpoint-up(xl) {
    font-size: 22px;
    line-height: 3.2vw;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 22px;
    line-height: 54px;
  }
}

.dollarsign {
  font-family: $font-graphik-regular;
  font-size: 3vw;
  line-height: 5.5vw;
  margin-left: 0px;
  margin-top: 0px;
  color: $couleur-blanc;
  @include media-breakpoint-up(md) {
    font-size: 18px;
    line-height: 30px;
  }
  @include media-breakpoint-up(lg) {
    font-size: 18px;
    line-height: 32px;
  }
  @include media-breakpoint-up(xl) {
    font-size: 20px;
    line-height: 34px;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 24px;
    line-height: 40px;
  }
}

.approx {
  display: inline;
  color: $couleur-blanc;
  font-family: $font-graphik-medium;
  font-size: 1vw;
  margin-left: -1.6vw;
  margin-top: 2.6vw;
  text-transform: uppercase;
  @include media-breakpoint-up(md) {
    font-size: 8px;
    margin-left: -10px;
    margin-top: 18px;
  }
  @include media-breakpoint-up(xl) {
    font-size: 8px;
    margin-left: -10px;
    margin-top: 20px;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 8px;
    margin-left: -16px;
    margin-top: 28px;
  }

  &.en {
    margin-top: 4vw;
    margin-left: 4px;
    @include media-breakpoint-up(md) {
      margin-top: 2.5vw;
    }
    @include media-breakpoint-up(lg) {
      margin-top: 2vw;
    }
    @include media-breakpoint-up(xl) {
      margin-top: 2vw;
    }
    @include media-breakpoint-up(xxl) {
      margin-top: 36px;
    }
  }
}

.casino {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 7vw;
  padding-top: 9vw;
  @include media-breakpoint-up(md) {
    padding-top: 0;
    height: 40%;
  }
  .logo-progressif {
    height: 16vw;
    @include media-breakpoint-up(md) {
      height: 100%;
      max-height: 90px;
    }
    width: auto;
  }
}

.boutons {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20%;
  align-items: end;
  text-transform: uppercase;
  font-family: $font-graphik-regular;
  font-size: 3.46667vw;
  @include media-breakpoint-up(md) {
    font-size: 1.33333vw;
  }
  @include media-breakpoint-up(lg) {
    font-size: 1.06667vw;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 1rem;
  }
  .jouer {
    left: 50%;
    text-decoration: none;
    border-radius: 8px 8px 0 0;
    background-color: $couleur-rouge;
    border: 2px solid $couleur-rouge;
    color: $couleur-blanc;
    text-transform: uppercase;
    padding: 3.06667vw 5.2vw 2.33333vw;
    @include media-breakpoint-up(md) {
      padding: 0.4rem 1rem 0rem;
    }
    @include media-breakpoint-up(lg) {
      padding: 0.4rem 1.6rem 0rem;
    }
    @include media-breakpoint-up(xxl) {
      padding: 0.3rem 1.5rem 0rem;
    }

    &:hover {
      background-color: transparent !important;
      color: $couleur-blanc;
      border-color: $couleur-blanc;
    }
  }
}
</style>
